import React from "react";
import { Modal } from "antd";
import { Localize } from "components/service";


const CheckQrRegenerateModal = ({ visible, pending, disabled, onConfirm, onCancel }) => (
    <Modal
        className="modal-standard event-check-qr-regenerate-modal"
        centered
        visible={ visible }
        title={ <Localize>CHECK_QR.Confirm_RegenerateTitle</Localize> }
        okText={ <Localize>CHECK_QR.Button_Regenerate</Localize> }
        cancelText={ <Localize>GLOBAL.Button_Text_Cancel</Localize> }
        confirmLoading={ pending }
        okButtonProps={ { danger: true, disabled: Boolean(disabled || pending) } }
        cancelButtonProps={ { disabled: pending } }
        closable={ !pending }
        keyboard={ !pending }
        maskClosable={ false }
        destroyOnClose
        onOk={ onConfirm }
        onCancel={ onCancel }>
        <Localize>CHECK_QR.Confirm_RegenerateText</Localize>
    </Modal>
);

export default CheckQrRegenerateModal;
